import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icone from 'Component/Icone';
import { useAppSelector } from 'Store';
import { useRecuperarAprovarIndisponibilidadesQuery } from 'View/Service/Default/AprovarIndisponibilidades';

const Folgas = (): React.ReactElement => {
  const navegacao = useNavigate();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const { data: { aprovar_indisponibilidades } = {} } =
    useRecuperarAprovarIndisponibilidadesQuery({
      contain: ['Indisponibilidades.Usuarios', 'Aprovou'],
      options: {
        usuario_id: usuario?.id,
        status: 3,
        visualizacao: usuario?.permissao == 'super' ? 2 : 1,
      },
    });

  return (
    <React.Fragment>
      {aprovar_indisponibilidades?.length ? (
        <div
          className="alert alert-danger cursor-pointer"
          onClick={() => navegacao(usuario?.permissao == 'super' ? '/indisponibilidades/aguardando?visualizacao=2' : '/indisponibilidades/aguardando')}
        >
          <strong className="me-3">
            <Icone nome="exclamation-circle-fill" /> Atenção
          </strong>
          Existem folgas para aprovar!
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Folgas;
